import { Range } from "immutable";

import { createAPI, updateAPI, getAPI, getAllAPI, deleteAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";

export const GET_OFFERS = "GET_OFFERS";
export const GET_OFFERS_SUCCESS = "GET_OFFERS_SUCCESS";
export const GET_OFFERS_ERROR = "GET_OFFERS_ERROR";
export const GET_OFFERS_FINALLY = "GET_OFFERS_FINALLY";

export const GET_OFFER = "GET_OFFER";
export const GET_OFFER_SUCCESS = "GET_OFFER_SUCCESS";
export const GET_OFFER_ERROR = "GET_OFFER_ERROR";
export const GET_OFFER_FINALLY = "GET_OFFER_FINALLY";

export const CREATE_OFFER = "CREATE_OFFER";
export const CREATE_OFFER_SUCCESS = "CREATE_OFFER_SUCCESS";
export const CREATE_OFFER_ERROR = "CREATE_OFFER_ERROR";
export const CREATE_OFFER_FINALLY = "CREATE_OFFER_FINALLY";

export const UPDATE_OFFER = "UPDATE_OFFER";
export const UPDATE_OFFER_SUCCESS = "UPDATE_OFFER_SUCCESS";
export const UPDATE_OFFER_ERROR = "UPDATE_OFFER_ERROR";
export const UPDATE_OFFER_FINALLY = "UPDATE_OFFER_FINALLY";

export const DELETE_OFFER = "DELETE_OFFER";
export const DELETE_OFFER_SUCCESS = "DELETE_OFFER_SUCCESS";
export const DELETE_OFFER_ERROR = "DELETE_OFFER_ERROR";
export const DELETE_OFFER_FINALLY = "DELETE_OFFER_FINALLY";

export const SET_OFFER_PAGE = "SET_OFFER_PAGE";
export const SET_OFFER_SORT = "SET_OFFER_SORT";

export const OFFER_CLEAR_ERROR = "OFFER_CLEAR_ERROR";
export const OFFER_CLEAR_FORM = "OFFER_CLEAR_FORM";

export const SET_DELETE_STATUS = "SET_DELETE_STATUS";

const validateCreate = (validate, msg, fields) =>
  validate(fields)
    .prop("agencyUID")
    .required(msg["app.validation.required"])
    .prop("country")
    .required(msg["app.validation.required"])
    .prop("city")
    .required(msg["app.validation.required"])
    .prop("code")
    .required(msg["app.validation.required"])
    .prop("sex")
    .required(msg["app.validation.required"])
    .prop("startDate")
    .required(msg["app.validation.required"])
    .prop("isPromoted")
    .required(msg["app.validation.required"])
    .prop("isVisible")
    .required(msg["app.validation.required"])
    .getErrors();

export const getAll = () => async (dispatch, getState, utils) => {
  const data = getState().offer.meta.toJS();

  const action = GET_OFFERS;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = data => async (dispatch, getState, utils) => {
  const action = GET_OFFER;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const create = data => async (dispatch, getState, utils) => {
  const action = CREATE_OFFER;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      createAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const update = data => async (dispatch, getState, utils) => {
  const action = UPDATE_OFFER;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      updateAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const deleteOne = data => async (dispatch, getState, utils) => {
  const action = DELETE_OFFER;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      deleteAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );

    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = page => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_OFFER_PAGE,
    payload: { page }
  });

  dispatch(getAll());
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_OFFER_PAGE,
    payload: { page: 1 }
  });

  dispatch({
    type: SET_OFFER_SORT,
    payload: { field, dir }
  });

  dispatch(getAll());
};

export const clearError = field => ({
  type: OFFER_CLEAR_ERROR,
  payload: { field }
});

export const clearForm = () => ({
  type: OFFER_CLEAR_FORM
});

export const setDeleteStatus = status => ({
  type: SET_DELETE_STATUS,
  payload: { status }
});



// WEBPACK FOOTER //
// ./src/common/offer/actions.js